import FancyButtons from "../FancyButtons";

import style from "./style.module.scss";

export default function VideoAsk() {
    return <div className={style.videoAsk + " row"} style={{ position: "relative" }}>
        <iframe className="col" title="something" src="https://www.videoask.com/fu3jqup3g"
            allow="camera *; microphone *; autoplay *; encrypted-media *; fullscreen *; display-capture *;"
            width="100%"
            height="600px"
            style={{ border: "none", padding: 0 }}
        >
        </iframe>

        <FancyButtons />

    </div>
}